// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/advisor.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ApproveGateRequest, ApproveGateResponse, AssessVerdictsRequest, AssessVerdictsResponse, AttachDocumentRequest, CancelEngagementRequest, CancelEngagementResponse, CreateEngagementRequest, Engagement, EngagementDocument, GetCompanyScaffoldRequest, GetCompanyScaffoldResponse, GetDossierRequest, GetDossierResponse, GetEngagementActivityRequest, GetEngagementActivityResponse, GetEngagementRequest, ListEngagementDocumentsRequest, ListEngagementDocumentsResponse, ListEngagementsRequest, ListEngagementsResponse, ListFindingsRequest, ListFindingsResponse, ListLensOpinionsRequest, ListLensOpinionsResponse, ListPersonasRequest, ListPersonasResponse, ListRequesterQuestionsRequest, ListRequesterQuestionsResponse, StartEngagementRequest, SubmitEvidenceRequest, SubmitEvidenceResponse, TranslateTextsRequest, TranslateTextsResponse, UpdatePersonaPromptRequest, UpdatePersonaPromptResponse, UpdateRedFlagStateRequest, UpdateRedFlagStateResponse } from "./advisor_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.AdvisorService
 */
export const AdvisorService = {
  typeName: "omnios.v1.AdvisorService",
  methods: {
    /**
     * @generated from rpc omnios.v1.AdvisorService.CreateEngagement
     */
    createEngagement: {
      name: "CreateEngagement",
      I: CreateEngagementRequest,
      O: Engagement,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.StartEngagement
     */
    startEngagement: {
      name: "StartEngagement",
      I: StartEngagementRequest,
      O: Engagement,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.AttachDocument
     */
    attachDocument: {
      name: "AttachDocument",
      I: AttachDocumentRequest,
      O: EngagementDocument,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.ListEngagementDocuments
     */
    listEngagementDocuments: {
      name: "ListEngagementDocuments",
      I: ListEngagementDocumentsRequest,
      O: ListEngagementDocumentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.GetEngagement
     */
    getEngagement: {
      name: "GetEngagement",
      I: GetEngagementRequest,
      O: Engagement,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.ListEngagements
     */
    listEngagements: {
      name: "ListEngagements",
      I: ListEngagementsRequest,
      O: ListEngagementsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.ApproveGate
     */
    approveGate: {
      name: "ApproveGate",
      I: ApproveGateRequest,
      O: ApproveGateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.SubmitEvidence
     */
    submitEvidence: {
      name: "SubmitEvidence",
      I: SubmitEvidenceRequest,
      O: SubmitEvidenceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.ListLensOpinions
     */
    listLensOpinions: {
      name: "ListLensOpinions",
      I: ListLensOpinionsRequest,
      O: ListLensOpinionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.ListRequesterQuestions
     */
    listRequesterQuestions: {
      name: "ListRequesterQuestions",
      I: ListRequesterQuestionsRequest,
      O: ListRequesterQuestionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.GetDossier
     */
    getDossier: {
      name: "GetDossier",
      I: GetDossierRequest,
      O: GetDossierResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.GetCompanyScaffold
     */
    getCompanyScaffold: {
      name: "GetCompanyScaffold",
      I: GetCompanyScaffoldRequest,
      O: GetCompanyScaffoldResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.CancelEngagement
     */
    cancelEngagement: {
      name: "CancelEngagement",
      I: CancelEngagementRequest,
      O: CancelEngagementResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.AssessVerdicts
     */
    assessVerdicts: {
      name: "AssessVerdicts",
      I: AssessVerdictsRequest,
      O: AssessVerdictsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.ListFindings
     */
    listFindings: {
      name: "ListFindings",
      I: ListFindingsRequest,
      O: ListFindingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.UpdateRedFlagState
     */
    updateRedFlagState: {
      name: "UpdateRedFlagState",
      I: UpdateRedFlagStateRequest,
      O: UpdateRedFlagStateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.ListPersonas
     */
    listPersonas: {
      name: "ListPersonas",
      I: ListPersonasRequest,
      O: ListPersonasResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.UpdatePersonaPrompt
     */
    updatePersonaPrompt: {
      name: "UpdatePersonaPrompt",
      I: UpdatePersonaPromptRequest,
      O: UpdatePersonaPromptResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.GetEngagementActivity
     */
    getEngagementActivity: {
      name: "GetEngagementActivity",
      I: GetEngagementActivityRequest,
      O: GetEngagementActivityResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AdvisorService.TranslateTexts
     */
    translateTexts: {
      name: "TranslateTexts",
      I: TranslateTextsRequest,
      O: TranslateTextsResponse,
      kind: MethodKind.Unary,
    },
  }
};

